/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon20Light = forwardRef('LogoTwitterIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.744 3.827a.5.5 0 1 0-.755-.654l-4.24 4.892-3.59-4.747A.8.8 0 0 0 6.521 3H4.103a.8.8 0 0 0-.638 1.282l4.92 6.51-4.663 5.38a.5.5 0 0 0 .756.655l4.524-5.22 3.838 5.076a.8.8 0 0 0 .638.317h2.419a.8.8 0 0 0 .638-1.283l-5.17-6.837 4.38-5.053ZM13.578 16 4.505 4h1.917l9.073 12h-1.917Z" })));
});
